export default __webpack_public_path__ + "static/media/LilNounsReadingHyperCosplay.e10ffbb0.png";